module.exports = __webpack_public_path__ + "img/check_mark_icon.b790e2ad.svg";